import React from "react";
import { Slide } from "@material-ui/core";

const SlideTransitionComponent = (props: any) => {
  const { direction } = props;
  return <Slide {...props} direction={direction || "up"} />;
};
export default SlideTransitionComponent;
